var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "key_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#key_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 14.583q-1.91 0-3.246-1.336T1.25 10.002q0-1.91 1.337-3.247 1.337-1.338 3.246-1.338 1.296 0 2.401.687A4.5 4.5 0 0 1 9.91 7.917h7.334q.62 0 1.064.442.442.443.442 1.064v1.154q0 .621-.442 1.064a1.45 1.45 0 0 1-1.064.442h-.16v.994q0 .621-.443 1.064a1.45 1.45 0 0 1-1.064.442h-1.154a1.45 1.45 0 0 1-1.064-.442 1.45 1.45 0 0 1-.442-1.064v-.994H9.91a4.5 4.5 0 0 1-1.676 1.813 4.46 4.46 0 0 1-2.4.687m0-1.25q1.375 0 2.209-.844.833-.843 1-1.656h5.125v2.244a.25.25 0 0 0 .072.184.25.25 0 0 0 .184.072h1.154a.25.25 0 0 0 .184-.072.25.25 0 0 0 .072-.184v-2.244h1.41a.25.25 0 0 0 .185-.072.25.25 0 0 0 .072-.184V9.423a.25.25 0 0 0-.072-.184.25.25 0 0 0-.184-.073H9.042q-.167-.812-1-1.656-.834-.843-2.209-.843a3.2 3.2 0 0 0-2.354.979A3.2 3.2 0 0 0 2.5 10q0 1.374.98 2.354a3.2 3.2 0 0 0 2.353.98m0-1.987q.555 0 .951-.396.396-.395.395-.95 0-.555-.395-.95a1.3 1.3 0 0 0-.95-.396q-.556 0-.951.395-.396.396-.396.95 0 .557.396.951.395.396.95.396"
  }))));
};
export default SvgKey;